export const TPA_EXPERIMENTS = {
  INSTALL_ECOM: 'specs.membership.InstallEcom',
  BREAKPOINT_INDICATORS_OOI: 'specs.membership.breakpointIndicatorsOOI',
  ECOM_GEOIP_ADDRESS: 'specs.membership.EcomGeoIpAddress',
  SETTINGS_EVENTS_FIX: 'specs.membership.SettingsEventsFix',
  BUTTON_HOVER_SETTINGS_EDITOR: 'specs.membership.ButtonHoverSettingsEditor',
  BUTTON_HOVER_SETTINGS_VIEWER: 'specs.membership.ButtonHoverSettingsViewer',
  PLAN_LIST_V2: 'specs.membership.PlanListV2',
  CHECKOUT_TRIGGER_ON_LOGIN_ONCE: 'specs.membership.CheckoutTriggerOnLoginOnce',
  SUGGEST_ECOM_MIGRATION: 'specs.pricingPlans.SuggestEcomMigration',
  IMPROVE_ECOM_LOADING_STATE: 'specs.PricingPlans.ImproveEcomLoadingState',
  START_DATE_FUNCTIONS: 'specs.membership.ShowStartDateFunctionTPA',
  ADD_TO_CART: 'specs.pricingPlans.AddToCart',
  SHOW_PAYWALL_SETTINGS: 'specs.pricing_plans.show_paywall_settings',
  ECOM_TYP_SAFE_ERROR_HANDLING: 'specs.pricingPlans.EcomTypSafeErrorHandling',
  ECOM_ADD_TO_CART_V2: 'specs.pricingPlans.EcomAddToCartV2',
  ECOM_CHECKOUT_API_UPDATE: 'specs.pricingPlans.EcomCheckoutApiUpdate',
  CASHIER_COUPON_DISCOUNT: 'specs.pricingPlans.CashierCouponDiscount',
  PLAN_V3_MIGRATION: 'specs.pricingPlans.PlanV3Migration',
  MIGRATE_TO_CART_V2: 'specs.pricingPlans.MigrateToCartV2'
};
//# sourceMappingURL=tpa.js.map